import {Component, Input, OnInit} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";

@Component({
	selector: "app-info-field",
	templateUrl: "./info-field.component.html",
	styleUrls: ["./info-field.component.scss"]
})
export class InfoFieldComponent implements OnInit {
	@Input() customText: string;
	@Input() i18nCode: string;
	@Input() color: string;
	splitRegExp = /\\[rn] |{{NEWLINE}}/g;
	texts: Array<string>;
	constructor(
		private translateService: TranslateService
	) {}

	ngOnInit() {
		if (this.i18nCode) {
			this.createTexts(this.translateService.instant(this.i18nCode));
			this.translateService.onLangChange.subscribe(() => {
				this.createTexts(this.translateService.instant(this.i18nCode));
			});
		} else {
			this.createTexts(this.customText);
		}
	}

	createTexts(texts: string) {
		this.texts = texts.split(this.splitRegExp).map(text => {
			return text.trim();
		});
	}

}
